export default __webpack_public_path__ + "assets/366a9bd91a10334053033e0c5f1522dd.png";